import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-complaint-category-master',
  templateUrl: './complaint-category-master.component.html',
  styleUrls: ['./complaint-category-master.component.scss']
})
export class ComplaintCategoryMasterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  opencomplaintcategoryModal(){
    document.getElementById("complaintcategoryModal").style.display='block'; 
  }

  closecomplaintcategoryModal(){
    document.getElementById("complaintcategoryModal").style.display='none';
  }
}
